<template>
  <div
    class="flex flex-col py-4 md:pb-0 px-5 md:px-6 gap-4 bg-primary overflow-y-auto"
  >
    <TextInput
      :modelValue="email"
      @update:modelValue="$emit('update:email', $event)"
      :label="$t('components.profile.email.fields.current.label')"
      :size="maxSmall ? 'lg' : 'sm'"
      :disabled="true"
    />
    <TextInput
      :modelValue="new_email"
      @update:modelValue="$emit('update:new_email', $event)"
      :label="$t('components.profile.email.fields.new.label')"
      :errorMessage="errors.new_email?.[0]"
      :size="maxSmall ? 'lg' : 'sm'"
    />
    <TextInput
      :modelValue="new_email_confirmation"
      @update:modelValue="$emit('update:new_email_confirmation', $event)"
      :label="$t('components.profile.email.fields.confirm_new.label')"
      :size="maxSmall ? 'lg' : 'sm'"
      :errorMessage="errors.new_email_confirmation?.[0]"
      aria-autocomplete="none"
    />
  </div>
</template>

<script setup>
import { TextInput } from "@/SharedComponents/Inputs";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineProps({
  email: { type: String, required: true },
  new_email: { type: String, required: true },
  new_email_confirmation: { type: String, required: true },
  errors: { type: Object, default: () => ({}) },
});
</script>
